/*
 * � 2020 Microsoft. All rights reserved.
 */

define('gameconfig',['text!gameconfig.json'], function(gc) {

    return JSON.parse(gc);

});

